import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = async function (data) {
	console.log("Attempting login with data:", data);
	return await Promise.allSettled([
		fetch({
			url: '/admin/auth/signin',
			method: 'post',
			data
		}),
		fetch({
			url: '/manager/auth/login',
			method: 'post',
			data
		})
	]).then(results => {
		// Try admin first
		if (results[0].status === "fulfilled") {
			console.log("Admin login successful", results[0].value);
			return results[0].value;
		}
		// If admin failed, try manager
		if (results[1].status === "fulfilled") {
			console.log("Manager login successful", results[1].value);
			return results[1].value;
		}
		console.error("Both login attempts failed", results);
		// If both failed, throw an error
		throw new Error("Both admin and manager login failed");
	});
};

AuthService.register = function (data) {
	return fetch({
		url: '/admin/auth/signup',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/admin/auth/logout',
		method: 'post'
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/admin/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;